<!--运行维护-设备故障处理-->
<template>
  <div class="device-failure">
    <!-- 工具条 -->
    <el-row>
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
        <el-form :inline="true" :model="filter" size="mini">
          <el-form-item>
            <el-select
              @change="handleFilterChange"
              v-model="filter.LocaleId"
              filterable
              remote
              clearable
              :remote-method="remoteMethod"
              placeholder='监测点'
            >
              <el-option
                v-for="item in locale"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              @change="handleFilterChange"
              v-model="filter.AbnormalStatus"
              filterable
              clearable
              placeholder='异常状态'
            >
              <el-option
                v-for="item in maintenanceAbnormalOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-cascader
              placeholder="所属单位"
              @change="handleFilterChange"
              v-model="filter.Owner"
              :options="customerTree"
              :props="customerProps"
              clearable
              filterable />
          </el-form-item>
          <el-form-item label="报警日期">
            <el-date-picker
              type="daterange"
              v-model="filter.AlarmAt"
              @change="handleFilterChange"
              format="yyyy-MM-dd"
              value-format="timestamp"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select
              @change="handleFilterChange"
              v-model="filter.Status"
              filterable
              clearable
              placeholder='操作状态'
            >
              <el-option
                v-for="item in maintenanceStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理日期">
            <el-date-picker
              type="daterange"
              v-model="filter.MaintainAt"
              @change="handleFilterChange"
              format="yyyy-MM-dd"
              value-format="timestamp"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-download"
              @click="openExportSizeInput"
              :loading="exportLoading"
            >
              导出
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!-- 列表 -->
    <el-table  @selection-change="selsChange" :max-height="clientHeight"  :data='dataObj.list' size='mini' border highlight-current-row v-loading='loading' style='width: 100%'>
      <el-table-column type="selection"/>
      <el-table-column type='index' label='#' align='center' width='55'/>
      <el-table-column prop='LocaleName' label='监测点' show-overflow-tooltip header-align='center'></el-table-column>
      <el-table-column prop='Addr' label='监测点地址' show-overflow-tooltip
                       header-align='center' min-width="150"></el-table-column>
      <el-table-column prop='MN' label='设备编号' width="230" align='center'>
        <template slot-scope="scope">
          {{ MNFormatter(scope.row.MN) }}
        </template>
      </el-table-column>
      <el-table-column prop='AbnormalStatus' label='异常状态' align='center' width="150" :formatter="AbnormalStatusFormatter"></el-table-column>
      <el-table-column prop='AlarmAt' label='报警日期' :formatter="dateFormatter" align='center'
                       width="110"></el-table-column>
      <el-table-column prop='MaintainerName' label='运维人员' show-overflow-tooltip
                       align="center" header-align='center' width="100"></el-table-column>
      <el-table-column prop="MaintainAt" :formatter="dateFormatter" label="处理日期"
                       align="center" width="110" header-align="center"></el-table-column>
      <el-table-column
        prop="Handler"
        label="处理人员"
        align="center"
        width="100"
        header-align="center"
      />
      <el-table-column
        prop="Status"
        label="操作状态"
        :formatter="maintenanceStatusFormatter"
        align="center"
        width="100"
        header-align="center"
      ></el-table-column>
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        width="120"
        header-align="center"
      >
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handleDownloadDocx(scope.row.Id)">导出</el-button>
          <el-button type="text" size="mini" @click="handleDeal(scope.$index, scope.row)" :disabled="scope.row.Status === 1 || (role !== 'sa' && role !== 'Maintainer' && role !== 'Charger')">处理</el-button>
          <el-button type="text" size="mini" @click="handleLook(scope.$index, scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 处理-->
    <el-dialog
      :title="dlg.title"
      :visible.sync="dlg.visible"
      @close="handlerClose"
      width="45%"
      top="20px"
    >
      <div style="overflow-y: auto; height: 70vh">
        <el-form
          :model="formData"
          :rules="formRule"
          ref="form"
          size="mini"
          label-width="84px"
          label-position="left"
          :disabled="isView"
        >
          <el-form-item prop="AbnormalStatus" label="异常状态">
            <el-select
              v-model="formData.AbnormalStatus"
              disabled
              placeholder="无"
            >
              <el-option
                v-for="item in maintenanceAbnormalOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="LocaleId" label="监测点名称">
            <el-input
              v-model="formData.LocaleName"
              disabled
              placeholder="无"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="LocalAddr" label="监测点地址">
            <el-input
              v-model="formData.Addr"
              disabled
              placeholder="无"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="MN" label="设备编号">
            <el-input
              v-model="formData.MN"
              disabled
              placeholder="无"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="AlarmAt" label="报警日期">
            <el-date-picker
              disabled
              placeholder="无"
              type="date"
              value-format="timestamp"
              format="yyyy-MM-dd"
              v-model="formData.AlarmAt"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="MaintainerId" label="运维人员">
            <el-select
              @change="maintainerChange"
              v-model="formData.MaintainerId"
              clearable
              :disabled="isView=='view'"
              placeholder="选择运维人员"
            >
              <el-option
                v-for="item in MaintainerList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="MaintainAt" label="处理日期">
            <el-date-picker
              disabled
              placeholder="无"
              type="date"
              value-format="timestamp"
              format="yyyy-MM-dd"
              v-model="formData.MaintainAt"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="DeviceFailureCause" label="异常原因">
            <el-select
              v-model="formData.DeviceFailureCause"
              @change="hasChange"
              :disabled="!isDeal || formData.MaintainAt > 0"
              placeholder="无"
            >
              <el-option
                v-for="item in maintenanceDeviceFailureCauseOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="Resolution" label="处理措施及结果">
            <el-input
              @change="hasChange"
              type="textarea"
              :rows="2"
              autosize
              v-model.trim="formData.Resolution"
            ></el-input>
          </el-form-item>
          <el-form-item prop="Pos" label="定位">
            <baidu-map
              class="bm-view"
              :center="mapCenter"
              :zoom="mapZoom"
              ak="770b4c07458f53896ff0abd948755e20"
              @ready="handleMapReady"
              v-if="isDeal"
            >
              <bm-geolocation
                anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                :showAddressBar="true"
                :autoLocation="true"
                @locationSuccess="getPosition"
              ></bm-geolocation>
            </baidu-map>
            <span>{{ formData.Position ? formData.Position : '暂无定位' }}</span>
          </el-form-item>
          <el-form-item
            prop="status"
            label="处理结果"
          >
            <el-select
              style="width: 100%"
              v-model="formData.Status"
              clearable
              placeholder='处理结果'
            >
              <el-option label="待处理" :value="3"></el-option>
              <el-option label="处理中" :value="2"></el-option>
              <el-option label="已完成" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-image
              class="view-img"
              v-for="(item, i) in fileList"
              :key="i"
              :src="item"
              :preview-src-list="fileList"
            >
              <div slot="error" class="image-slot">
                暂无图片
              </div>
            </el-image>
          </el-form-item>
          <el-form-item>
            <el-upload
              ref="upload"
              :disabled="!isDeal"
              accept=".jpg, .jpeg, .png"
              list-type="picture-card"
              :action="upload()"
              :on-success="handleAvatarSuccess"
              :limit="4"
              :before-upload="hasChange"
              :on-exceed="handleExceed"
              :on-remove="handleRemove"
              :on-preview="handlePreview"
            >
              <i class="el-icon-plus" />
              <div slot="tip">上传照片（最多4张，支持jpg、jpeg、png）</div>
            </el-upload>
          </el-form-item>
          <template v-if="eventRecords.length>0">
            <el-form-item label="处理记录">
              <el-timeline>
                <el-timeline-item v-for="item in eventRecords" :key="item.index"  :timestamp="'第'+item.index+'次处理记录'" placement="top">
                  <el-card>
                    <h4>处理日期: <span style="font-size: 14px;margin-left:38px;color:#aaaaaa;font-weight: 400;">{{dateFormat(item.handle_at)}}</span></h4>
                    <h4>处理人员: <span style="font-size: 14px;margin-left:38px;color:#aaaaaa;font-weight: 400;">{{item.handle_name}}</span></h4>
                    <h4>处理措施: <span style="font-size: 14px;margin-left:38px;color:#aaaaaa;font-weight: 400;">{{item.solution}}</span></h4>
                    <div v-if="item.handle_pics.length > 0">
                      <el-image v-for="(pic,index) in item.handle_pics" :key="index" :src="pic" :preview-src-list="item.handle_pics" style="width: 100px;height: 100px;margin-left:10px;" />
                    </div>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" v-if="isDeal">
        <el-button size="mini" @click.native="dlg.visible = false">取消</el-button>
        <el-button type="primary" size="mini" @click.native="handleSubmit">提交</el-button>
      </div>
    </el-dialog>
    <!-- 图片展示-->
    <el-dialog :visible.sync="showImg">
      <el-image
        :src="dialogImageUrl"
        fit="fill"
        :preview-src-list="fileList"
      >
        <div slot="error" class="image-slot">
          暂无图片
        </div>
      </el-image>
    </el-dialog>
    <!-- 工具条 -->
    <div class="toolbar" >
      <el-button
        size="mini"
        @click="bulkDownload"
        :disabled="sels.length === 0"
      >批量导出
      </el-button>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="filter.page"
        :page-sizes="filter.pageSizes"
        :page-size="filter.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="dataObj.total"
        style="display: inline-block; margin-left: 15px">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  dateFormater,
  getUserInfo,
  join,
  ifNull,
  maintenanceStatusFormatter,
  maintenanceStatusOptions,
  maintenanceAbnormalOptions,
  maintenanceDeviceFailureCauseOptions,
  export_json, ownerJoin
} from '@/util/index'
import conf from '@/config'
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmGeolocation from 'vue-baidu-map/components/controls/Geolocation'

const assembleParam = (param, download = false) => {
  const r = {
    StartAt: (param.page - 1) * param.size,
    Size: download ? 1000 : param.size,
    FormType: 2,
    Param: {}
  }
  if (param.LocaleId) {
    r.Param['maintenance.locale_id'] = { S: 2, V: param.LocaleId.toString() }
  }
  if (param.AbnormalStatus) {
    r.Param['maintenance.abnormal_status'] = { S: 0, V: param.AbnormalStatus.toString() }
  }
  if (param.Owner && param.Owner.length > 0) {
    const owner = `${ownerJoin(param.Owner, param.userInfo)}`
    r.Param['maintenance.owner'] = { S: 4, V: owner }
  }
  if (param.AlarmAt) {
    r.Param['maintenance.alarm_at'] = []
    r.Param['maintenance.alarm_at'].push(0 | param.AlarmAt[0] / 1000)
    r.Param['maintenance.alarm_at'].push((0 | param.AlarmAt[1] / 1000) + 86400)
    r.Param['maintenance.alarm_at'] = { S: 11, V: r.Param['maintenance.alarm_at'].toString() }
  }
  if (param.MaintainAt) {
    r.Param['maintenance.maintain_at'] = []
    r.Param['maintenance.maintain_at'].push(0 | param.MaintainAt[0] / 1000)
    r.Param['maintenance.maintain_at'].push((0 | param.MaintainAt[1] / 1000) + 86400)
    r.Param['maintenance.maintain_at'] = { S: 11, V: r.Param['maintenance.maintain_at'].toString() }
  }
  if (param.Status || param.Status === 2) {
    r.Param['maintenance.status'] = { S: 0, V: param.Status.toString() }
  }
  return r
}

export default {
  components: {
    BaiduMap,
    BmGeolocation
  },
  data() {
    return {
      mapCenter: { lng: 120.306305, lat: 30.424877 },
      mapZoom: 14,
      maintenanceStatusOptions,
      maintenanceAbnormalOptions,
      maintenanceDeviceFailureCauseOptions,
      postdata: {
        Page: 1, // 页码，自用
        PerPage: 10, // 页数，自用
        StartAt: 0, // 起始偏移量
        Size: 20, // 每页显示数量
        OwnerName: '', // 监测点名称
        Type: null, // 设备状态 2 // 异常离线；3 // 数据异常偏大；4 // 数据异常偏小；5 // 在线时间短；6 // 数据漂移异常
        OwnerId: [], // 所属单位
        RecordAtStart: '', // 异常日期开始时间
        RecordAtEnd: '', // 异常日期结束时间
        Status: null, // 操作状态 1 // 异常数据 待处理；2 // 异常数据 已派单；3 // 异常数据 正常
        HandleAtStart: '', // 处理日期开始时间
        HandleAtEnd: '' // 处理日期结束时间
      },
      PanicRangeTime: [], // 异常日期时间，自用
      HandleRangeTime: [], // 处理日期时间，自用,
      showImg: false,
      dialogImageUrl: null,
      exportLoading: false,
      loading: false,
      filter: {
        page: 1,
        size: 20,
        pageSizes: [20, 30, 50]
      },
      dataObj: {
        list: [],
        pages: 0,
        total: 0
      },
      sels:[],
      dlg: {
        visible: false,
        type: null,
        title: ''
      },
      MaintainerList: [],
      formData: {},
      formRule: {
        DeviceFailureCause: [{ required: true, message: '异常原因不可为空', trigger: 'blur' }],
        Resolution: [{ required: true, message: '处理措施不可为空' ,trigger: 'blur' }]
      },
      // 操作异常数据入参
      updatePostdata: {
        show: false, // 显示派单对话框
        loading: false, // 数据请求加载状态
        Id: null,
        Status: null, // 操作状态：2 // 异常数据 已派单；3 // 异常数据 正常
        Resolution: '' // 操作状态为2时，需要传 解决措施
      },
      updateRulesCustom: {
        Resolution: [
          { required: true, message: '请选择维护类型', trigger: 'change' }
        ]
      },
      changeState: false,
      isShowProcessRecordDialog: false, // 是否显示处理记录对话框
      maintainType: '',
      isDeal: false,
      isView: false,
      fileList: [],
      eventRecords:[],
      role: null,
      locale: [],
    }
  },
  computed: {
    ...mapState({
      customerProps: state => Object.assign({}, state.props, { label: 'Org', checkStrictly: true })
    }),
    ...mapState(['customerTree', 'user', 'clientHeight'])
  },
  created() {
    this.userInfo = getUserInfo().Info
    this.role = sessionStorage.getItem('role')
    let param = {
      StartAt: 0,
      Size: 20,
    }
    this.$post('admin/listLocale', param).then(res => {
      this.locale = res.content
    })
    this.$get('admin/listMaintainer').then(res => {
      this.MaintainerList = res
    })
    this.netGetMessageList() // 获取列表
  },
  methods: {
    selsChange: function (sels) {
      this.sels = sels
    },
    bulkDownload: function () {
      if (this.sels.length !== 0) {
        const ids = this.sels.map((item) => item.Id).toString()
        this.$confirm('确认导出选中记录吗？', '提示', {
          type: 'warning'
        })
          .then(() => {
            this.handleDownloadDocx(ids)
          })
          .catch(() => {
          })
      }
    },
    handleDownloadDocx(ids){
      const loading = this.$loading({
        lock: true,
        text: '数据导出中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      this.$get('admin/downloadMaintenance/'+ids, {})
      .then((res) => {
        for(var i = 0; i < res.urls.length; i++) {
          const iframe = document.createElement('iframe')
          iframe.style.display = 'none'
          iframe.style.height = 0
          iframe.src = res.urls[i]
          document.body.appendChild(iframe)
          setTimeout(() => {
            iframe.remove()
          }, 5000)
        }
        loading.close()
      })
      .catch(() => {
        loading.close()
      })
    },
    maintainerChange() {
      this.formData.MaintainerName = ""
      for(var i = 0; i < this.MaintainerList.length; i++) {
        if (this.formData.MaintainerId == this.MaintainerList[i].Id) {
          this.formData.MaintainerName = this.MaintainerList[i].Name
          break
        }
      }
    },
    getEventInfo(id) {
      this.eventRecords = []
      this.$get('admin/listEvent/info/' + id,{typ: 4}).then(res => {
        for(var i = 0; i < res.eventHandleRecords.length; i++) {
          res.eventHandleRecords[i].index = i+1
          if (res.eventHandleRecords[i].handle_pics != "") {
            res.eventHandleRecords[i].handle_pics = res.eventHandleRecords[i].handle_pics.split(",")
          } else {
            res.eventHandleRecords[i].handle_pics = []
          }
        }
        this.eventRecords = res.eventHandleRecords
      })
    },
    dateFormat(r) {
      return dateFormater(r, true);
    },
    openExportSizeInput() {
      this.$prompt(`请输入导出的数据量（总量：${this.dataObj.total} 条）`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: '只能填入数字'
      }).then(({ value }) => {
        this.handleDownload(parseInt(value))
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        })
      })
    },
    handlePreview(file) {
      this.showImg = true
      this.dialogImageUrl = file.response.Data
    },
    handleMapReady() {
      if (this.formData.Lng && this.formData.Lat) {
        this.mapCenter = [this.formData.Lng, this.formData.Lat]
      }
    },
    getPosition(pos) {
      console.log(pos)
      this.formData.Lng = pos.point.lng.toString()
      this.formData.Lat = pos.point.lat.toString()
      this.formData.Position = pos.addressComponent['province'] + pos.addressComponent['city'] +
        pos.addressComponent['district'] + pos.addressComponent['street'] +
        pos.addressComponent['streetNumber']
    },
    upload() {
      return conf.uploadApi + '/uploadToOss'
    },
    handleAvatarSuccess(res, file) {
      this.formData.MaintenancePics.push({ MaintenanceId: this.formData.Id, PicUrl: res.Data })
    },
    handleExceed(files, fileList) {
      this.$message.warning(`照片数量限制在4张`)
    },
    handleRemove(file, fileList) {
      console.log(file)
      this.formData.MaintenancePics.forEach((v, index) => {
        if (file.response) {
          if (v.PicUrl === file.response.data) {
            this.formData.MaintenancePics.splice(index, 1)
          }
        } else {
          if (v.PicUrl === file.url) {
            this.formData.MaintenancePics.splice(index, 1)
          }
        }
      })
      const i = this.formData.MaintenancePics.indexOf(file.response.data)
      this.formData.MaintenancePics.splice(i, 1)
    },
    /**
     * @return {string}
     */
    MNFormatter(mn) {
      const arr = mn.split('-')
      let s = ''
      for (let i = 0; i < arr.length; i++) {
        if (arr[i]) {
          s = s + arr[i] + '\n'
        }
      }
      return s
    },
    /**
     * @return {string}
     */
    AbnormalStatusFormatter(r, c) {
      switch (r[c.property]) {
        case 1:
          return '风机监控异常'
        case 2:
          return '净化器监控异常'
        case 3:
          return '油烟检测传感异常'
        case 4:
          return '油烟监测异常'
        case 5:
          return '监控异常'
        case 6:
          return '监测仪、风机监控异常'
        default:
          return ''
      }
    },
    /**
     * @description 日期格式化
     */
    dateFormatter(r, c) {
      return dateFormater(r[c.property], false, false)
    },
    maintenanceStatusFormatter,
    // 新增方法：处理筛选条件变化
    handleFilterChange() {
      // 筛选条件变化时，重置页码到第一页
      this.filter.page = 1;
      this.netGetMessageList();
    },
    /**
     * @description 获取列表
     */
    netGetMessageList() {
      this.loading = true
      const payload = assembleParam({
        ...this.filter,
        userInfo: this.userInfo
      })
      this.$post('admin/listMaintenance', payload).then(res => {
        this.dataObj.list = res.content
        this.dataObj.total = res.total
        this.loading = false
      })

    },
    /**
     * @description 查询
     */
    searchData() {
      this.postdata.page = 1
      this.netGetMessageList()
    },

    /**
     * @description 每页条数
     */
    handleSizeChange(pageSize) {
      this.filter.page = 1
      this.filter.size = pageSize
      this.netGetMessageList()
    },

    /**
     * @description 页码
     */
    handleCurrentChange(page) {
      this.filter.page = page
      this.netGetMessageList()
    },
    /**
     * @description 操作
     */
    handleClick(status, row) {
      switch (status) {
        case '处理记录':
          this.isShowProcessRecordDialog = true
          break
      }
    },
    hasChange() {
      this.changeState = true
    },
    handleRefresh() {
      this.filter.page = 1
      this.filter.name = null
      this.netGetMessageList()
    },
    handleDeal(index, row) {
      this.dlg.title = '处理'
      this.dlg.visible = true
      this.isDeal = true
      this.index = index
      this.formData = Object.assign({}, row, {
        MaintenancePics: []
      })
      this.fileList = row.MaintenancePicS
      this.getEventInfo(row.Id)
    },
    handleLook(index, row) {
      this.dlg.title = '查看'
      this.dlg.visible = true
      this.isView = true
      this.index = index
      this.formData = Object.assign({}, row, {
        MaintenancePics: []
      })
      this.fileList = row.MaintenancePicS
      this.getEventInfo(row.Id)
    },
    handlerClose: function() {
      if (this.changeState) {
        this.changeState = false
        this.handleRefresh()
      }
      this.isView = false
      this.isDeal = false
      this.device = []
      if (this.$refs['form']) {
        this.$refs['form'].resetFields()
      }
      this.formData = {}
      this.$refs.upload.uploadFiles = []
    },
    /**
     * @description 处理监测点状态
     */
    updateStatus(id, status) {
      this.updatePostdata.loading = true
      this.$post('admin/handleAbnormalData', this.updatePostdata).then(msg => {
        console.log(msg)
        this.$message({
          message: msg || '操作成功',
          type: 'success'
        })
        this.updatePostdata.loading = false
        this.updatePostdata.show = false
        this.$refs.updatePostdata.resetFields()
        this.postdata.page = 1
        this.netGetMessageList()
      }).catch(() => {
        this.updatePostdata.loading = false
        this.$refs.updatePostdata.resetFields()
        this.updatePostdata.show = false
      })
    },

    /**
     * @description 提交表单
     */
    handleSubmit(name) {
      const uri = 'admin/updateMaintenance'
      if (!this.changeState) {
        this.dlg.visible = false
        return
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {})
            .then(() => {
              if (this.formData.Status == 3) {
                this.formData.Status = 2
              }
              this.formData.MaintenancePicS = []
              for(var i = 0; i < this.formData.MaintenancePics.length; i++) {
                this.formData.MaintenancePicS.push(this.formData.MaintenancePics[i].PicUrl)
              }
              delete this.formData.MaintenancePics;
              const para = Object.assign({}, this.formData)
              if (para.MaintainAt == 0) {
                para.MaintainAt =  Date.parse(new Date())
              }
              para.MaintainAt = para.MaintainAt / 1000
              para.CreateAt = (0 | this.formData.CreateAt / 1000)
              para.AlarmAt = (0 | this.formData.AlarmAt / 1000)
              this.$post(uri, para)
                .then(() => {
                  this.dlg.visible = false
                })
                .catch(() => {})
            })
            .catch(() => {})
        }
      })
    },
    handleDownload(exportSize) {
      //定义加载中的动画
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        target: document.querySelector(".submit-dialog") // .submit-dialog 指的是 el-dialog 的 class
      });
      this.exportLoading = true
      const payload = assembleParam({
        ...this.filter,
        ...this.userInfo
      }, true)
      payload.Size = exportSize
      payload.IsDownload = true
      this.$post('admin/listMaintenance', payload).then(res => {
        let url = res.url
        const link = document.createElement('a')
        link.setAttribute('href', url)
        link.click()
        loading.close()
        this.exportLoading = false
      })
    },
    remoteMethod(query){
      if (query !== '') {
        this.loading = true;
        let param = {
          StartAt: 0,
          Size: 20,
          Param: {
            Name: query
          }
        }
        this.$post('admin/listLocale', param).then(res => {
          this.loading = false;
          this.locale = res.content
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .device-failure {
    .page_box {
      padding: 30px 0;
      text-align: center;
    }
  }
  .view-img {
    width: 140px;
    height: 140px;
    margin: 0 10px;
  }
  .bm-view {
    width: 100%;
    height: 150px;
  }
  ::v-deep .el-table .cell {
    white-space: pre-line;
  }
</style>
